/**
 * This will track all the images and fonts for publishing.
 */
import.meta.glob(["../images/**", "../fonts/**"]);

import "../css/app.css";

/**
 * Main vue bundler.
 */
import { createApp } from "vue/dist/vue.esm-bundler";
import AnotherChevroneRight from "@/js/svg/AnotherChevroneRight.vue";

/**
 * Main root application registry.
 */
window.app = createApp({
    data() {
        return {};
    },

    mounted() {
        this.lazyImages();
    },

    methods: {
        onSubmit() {},

        onInvalidSubmit() {},

        lazyImages() {
            var lazyImages = [].slice.call(
                document.querySelectorAll("img.lazy"),
            );

            let lazyImageObserver = new IntersectionObserver(function (
                entries,
            ) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;

                        lazyImage.src = lazyImage.dataset.src;

                        lazyImage.classList.remove("lazy");

                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            });

            lazyImages.forEach(function (lazyImage) {
                lazyImageObserver.observe(lazyImage);
            });
        },
    },
});

/**
 * Global plugins registration.
 */
import Axios from "./plugins/axios";
import Emitter from "./plugins/emitter";
import Shop from "./plugins/shop";
import VeeValidate from "./plugins/vee-validate";

[Axios, Emitter, Shop, VeeValidate].forEach((plugin) =>
    app.use(plugin),
);

import { getMemoizedData, clearDataCache } from "./services/sharedDataService.ts";
window.getMemoizedData = getMemoizedData;
window.clearDataCache = clearDataCache;

/**
 * Global directives.
 */
import Debounce from "./directives/debounce";
import onClickOutside from "@/js/directives/on-click-outside.js";

app.directive("debounce", Debounce);
app.directive("on-click-outside", onClickOutside);

/**
 * Register search components
 */
import SearchInput from "./components/search/SearchInput.vue";

app.component("v-search-input", SearchInput);

app.component("AnotherChevroneRight", AnotherChevroneRight);

export default app;
